import {
  configureStore,
  ThunkAction,
  Action,
} from '@reduxjs/toolkit';
import userInfoSlice from 'src/api/features/userInfoSlice';
import authenSlice from 'src/api/features/authenSlice';
import departmentSlice from 'src/api/features/departmentSlice';
import userSlice from 'src/api/features/userSlice';
import generalSlice from 'src/api/features/generalSlice';
import projectSlice from 'src/api/features/projectSlice';
import userAllStatusSlice from 'src/api/features/userAllStatusSlice';
import menuSlice from 'src/api/features/menuSlice';

export const store = configureStore({
  reducer: {
    general: generalSlice,
    userInfo: userInfoSlice,
    authen: authenSlice,
    department: departmentSlice,
    user: userSlice,
    userAllStatus: userAllStatusSlice,
    project: projectSlice,
    menu: menuSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
